import { aligntogetherLogo, collegeLogo, schoolLogo, sercLogo, sipaLogo} from "./imageConstants";
import OtpVerification from '../images/OtpVerification.png'
import Blogify from '../images/Blogify.png'
import ShortUrl from '../images/shortUrl.png'
import WritingApp from '../images/AiWriting.jpg'
import GroupIcon from '../images/group.png'
import BookStore from '../images/Bookstore.png'
import ChatRoom from '../images/chatroom.png'
import kio from '../images/kiopio.jpg'
import mine from '../images/minecraft.jpg'
import nitk from "../images/nitk.avif"
import KoderBox from '../images/koderbox logo.jpg'
import KC from '../images/KC.avif'
import Kd from '../images/kd.png'
import Du from '../images/du.png'
import BB from '../images/BB.png'
import inci from "../images/inci.png";
import next from "../images/next-js.svg";
import videonetics from "../images/videonetics.png";
const checkIcon = "https://cdn-icons-png.flaticon.com/512/1828/1828817.png";
export const Bio = {
  name: "Neha Priya",
  roles: ["Web Developer", "Problem Solver", "Cat Mom :3"],
  description:
    "I am a result-oriented individual with a strong drive to learn and tackle new challenges. I thrive in environments that foster growth and encourage me to push my limits, constantly seeking opportunities to expand my skills and knowledge.",
  linkedin: "https://www.linkedin.com/in/neha-ekka-38613221a/",
  resume:
    "https://drive.google.com/file/d/1pwUkDf9fjTLRyatpYSJ8trLPGac_o12E/view?usp=sharing",
  github: "https://github.com/neha067",
  leetcode: "https://leetcode.com/u/neha067/",
  gfg: "https://www.geeksforgeeks.org/profile/neha067",
};

export const skills = [
  {
    title: "Languages",
    skills: [
      {
        name: "JavaScript (ES6+)",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Unofficial_JavaScript_logo_2.svg/1280px-Unofficial_JavaScript_logo_2.svg.png",
      },
      {
        name: "TypeScript",
        image: "https://img.icons8.com/color/512/typescript.png",
      },
      {
        name: "Python",
        image: "https://upload.wikimedia.org/wikipedia/commons/c/c3/Python-logo-notext.svg"
      }
    ],
  },
  {
    title: "Frontend",
    skills: [
      {
        name: "React.js",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg",
      },
      {
        name: "Next.js",
        image:
          "https://assets.vercel.com/image/upload/v1662130559/nextjs/Icon_dark_background.png",
      },
      {
        name: "Redux",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/redux/redux-original.svg",
      },
      {
        name: "Zustand",
        image:
          "https://user-images.githubusercontent.com/958486/218346783-72be5ae3-b953-4dd7-b239-788a882fdad6.svg",
      },
      {
        name: "HTML5",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg",
      },
      {
        name: "CSS3 / SCSS",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg",
      },
      {
        name: "Tailwind CSS",
        image:
          "https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg",
      },
    ],
  },
  {
    title: "Backend & APIs",
    skills: [
      {
        name: "Node.js",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original.svg",
      },
      {
        name: "Express.js",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/express/express-original.svg",
      },
      {
        name: "REST APIs",
        image: "https://cdn-icons-png.flaticon.com/512/2165/2165004.png",
      },
      {
        name: "GraphQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/graphql/graphql-plain.svg",
      },
    ],
  },
  {
    title: "Performance",
    skills: [
      {
        name: "Microservices",
        image: checkIcon,
      },
      {
        name: "SSR / SSG",
        image: checkIcon,
      },
      {
        name: "Code Splitting",
        image: checkIcon,
      },
      {
        name: "Lazy Loading",
        image: checkIcon,
      },
      {
        name: "Web Performance Optimization",
        image: checkIcon,
      },
    ],
  },
  {
    title: "Tools & DevOps",
    skills: [
      {
        name: "Git",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/git/git-original.svg",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original.svg",
      },
      {
        name: "Jenkins",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/jenkins/jenkins-original.svg",
      },
      {
        name: "AWS (EC2, S3)",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/amazonwebservices/amazonwebservices-original-wordmark.svg",
      },
      {
        name: "CI/CD Pipelines",
        image: "https://cdn-icons-png.flaticon.com/512/906/906334.png",
      },
    ],
  },
  {
    title: "Testing & Quality",
    skills: [
      {
        name: "Jest",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/jest/jest-plain.svg",
      },
      {
        name: "React Testing Library",
        image: "https://testing-library.com/img/octopus-128x128.png",
      },
      {
        name: "Unit Testing",
        image: checkIcon,
      },
      {
        name: "Integration Testing",
        image: checkIcon,
      },
    ],
  },
  {
    title: "Databases",
    skills: [
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original.svg",
      },
      {
        name: "SQL",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg",
      },
      {
        name: "VectorDB",
        image: "https://deepchecks.com/wp-content/uploads/2024/12/logo-vectordb.png"
      }
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: videonetics,
    role: "Software Engineer",
    company: "Videonetics Technology Pvt. Ltd.",
    date: "Aug 2024 - Present",
    desc: [
      "Designed and integrated an end-to-end agentic AI feature into a full-stack application (Python + React) using OpenAI GPT models, enabling natural language to SQL conversion with schema-aware validation, backend execution, and render interactive data visualization results through dynamic charts and graphs.",
      "Built a real-time emergency vehicle tracking system using WebSockets, achieving <200 ms latency and improving operator response efficiency by 30%.",
      "Developed a React-based Red Light Violation Detection analytics interface, reducing manual configuration time by 40% via visual zone plotting and automated coordinate syncing.",
      "Integrated WebRTC, STOMP/WebSockets, and Mapbox into a scalable video analytics platform supporting thousands of concurrent live streams with low latency.",
      "Led migration from a monolithic desktop application to a cloud-ready modular platform using React + Next.js, reducing load times by 45% and enabling multi-team extensibility.",
      "Designed and implemented scalable testing strategies using Jest and React Testing Library, leveraging AI-assisted tooling to improve productivity while maintaining strong edge-case coverage.",
    ],
    skills: [
      "React",
      "Next.js",
      "JavaScript",
      "WebSockets",
      "WebRTC",
      "Mapbox",
      "STOMP",
      "Jest",
      "React Testing Library",
      "Performance Optimization",
    ],
  },
  {
    id: 1,
    img: KC,
    role: "Software Engineer Intern",
    company: "Karbon Card",
    date: "Feb 2024 - Aug 2024",
    desc: [
      "Built a microservice using Django and Django Templates to generate Board Resolution documents, improving compliance turnaround time by 80%.",
      "Designed the system for extensibility, enabling future support for generating multiple document types.",
      "Developed pytest-based automated tests, increasing backend test coverage from 40% to 75% and reducing regression issues.",
      "Created CI/CD-integrated Cypress E2E tests, reducing QA cycles by 60% and accelerating release velocity.",
      "Improved frontend stability by implementing robust error handling and UX enhancements in React, reducing failures by 60%.",
    ],
    skills: [
      "Django",
      "Python",
      "Pytest",
      "Cypress",
      "Microservices",
      "CI/CD",
      "React",
      "Automation",
    ],
  },
  {
    id: 2,
    img: BB,
    role: "Software Developer Intern",
    company: "BellBucket Pvt. Ltd.",
    date: "Dec 2022 - Feb 2023",
    desc: [
      "Designed and implemented APIs for Order and Payment Systems using Node.js and Express, ensuring robust and reliable delivery.",
      "Performed comprehensive API testing using Postman to ensure bug-free releases.",
      "Implemented Redux-Saga for managing asynchronous order workflows, ensuring smooth and consistent state handling.",
    ],
    skills: [
      "Node.js",
      "Express",
      "Redux-Saga",
      "JavaScript",
      "Postman",
      "API Development",
    ],
  },
  {
    id: 3,
    img: Kd,
    role: "Summer Intern",
    company: "Kongsberg Digital",
    date: "May 2022 - July 2022",
    desc: [
      "Built a Python-based automation tool for a digital twin platform to optimize regex-driven asset retrieval, reducing manual workload from 3–4 days to 2–3 hours.",
      "Leveraged digitalization tools to extract actionable insights from complex datasets, enabling data-driven decision-making.",
    ],
    skills: [
      "Python",
      "Automation",
      "Regex",
      "Data Processing",
      "Digital Twin Systems",
    ],
  },
];

export const education = [
  {
    id: 0,
    img: nitk,
    school: "National Institute of Technology Karnataka",
    date: "Oct 2021 - June 2024",
    // grade: "7.80 CGPA",
    // desc: "I completed Bachelor's degree in Computer Science and Engineering at School of Information Technology, RGPV, Bhopal. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others.",
    degree:
      "Master of Computer Applications - MCA, Computer Science and Engineering",
  },
  {
    id: 1,
    img: Du,
    school: "Durg University",
    date: "Apr 2020 - Apr 2021",
    // grade: "83.4%",
    // desc: "I completed my class 12 high school education at kendriya vidyalaya, Damoh.",
    degree:
      "Bachelor of Computer Applications- BCA, Computer Science and Engineering",
  },
];

export const projects = [
  {
    id: 9,
    title: "KioPio | TypeScript | React | Next.js",
    date: "November 2025 - Present",
    description:
      "KioPio connects animal rescuers on a social platform to report, track, and find missing or found pets. A pet matching system using React, Next.js, TypeScript, Supabase pgvector, and vector embeddings, enabling semantic retrieval of related lost/found pet posts through nearest-neighbor similarity search.",
    image: kio,
    tags: ["TypeScript", "React", "Next.js", "Vercel", "Leaflet"],
    category: "web app",
    github: "https://github.com/neha067/findmypet",
    webapp: "https://www.kiopio.com/",
  },

  {
    id: 0,
    title: "VoxelCraft | JavaScript | React | Three.js",
    date: "August 2025 - August 2025",
    description:
      "VoxelCraft is a Minecraft-inspired 3D world built using React and Three.js, allowing players to place, remove, and interact with voxel blocks in a smooth, real-time rendered environment. The project features a custom block engine, dynamic lighting, optimized chunk rendering, and intuitive first-person controls for an immersive sandbox experience.",
    image: mine,
    tags: ["React", "Three.js", "JavaScript", "WebGL", "3D Rendering"],
    category: "web app",
    github: "https://github.com/neha067/minecraft-react",
    webapp: "https://minecraft-react-one.vercel.app/",
  },
  {
    id: 1,
    title: "NITK Incident’2024 | JavaScript | React | Three.js",
    date: "Jan 2024 - Feb 2024",
    description:
      "Worked on the frontend of the official website for NITK Incident’24 — the largest solely student-organised cultural fest in South India. Collaborated closely with the backend and Blender teams, implementing smooth transitions on 3D Blender models, managing camera perspectives, and creating interactive checkpoints for an immersive landing page experience.",
    image: inci,
    tags: ["React", "JavaScript", "Three.js", "WebGL", "Frontend"],
    category: "web app",
    github: "https://github.com/neha067/Incident",
    webapp: "https://incident-alpha.vercel.app/",
  },

  // {
  //   id: 6,
  //   title: "Blogify",
  //   date: "Jun 2025",
  //   description:
  //     "A modern blog platform where users can easily write, publish, and categorize blogs by topics such as Tech, Health, Sports, and more. Blogify enables community interaction with user authentication, blog management, and commenting features for an engaging blog-sharing experience.",
  //   image: Blogify,
  //   tags: ["React Js", "Node.js", "Express", "MongoDB","JWT","Bootstrap"],
  //   category: "web app",
  //   github: "https://github.com/ramanshparashar/Blogify",
  //   webapp: "",
  // },
  // {
  //   id: 7,
  //   title: "Short-url",
  //   date: "April 2025",
  //   description:
  //     "Short-Url is a simple and secure URL shortener that Converts long URLs into short, easy-to-share linksTracks click analytics for each shortened URL",
  //   image:ShortUrl,
  //   tags: ["Node.js", "Express", "MongoDB","Nanoid"],
  //   category: "web app",
  //   github: "https://github.com/ramanshparashar/Short-url",
  //   webapp: "",
  // },
  // {
  //   id: 8,
  //   title: "OTP - Verification",
  //   date: "Jan 2024",
  //   description:
  //     "Project focuses on implementing Firebase OTP authentication using React. This aims to seamlessly send and verify OTPs for user authenticatio",
  //   image:OtpVerification,
  //   tags: ["React", "Firebase", "OTP"],
  //   category: "web app",
  //   github: "https://github.com/ramanshparashar/otp-verification",
  //   webapp: "",
  // },
];

